var _path, _path2, _mask, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12C1 9.23858 3.23858 7 6 7H20C22.7614 7 25 9.23858 25 12V20C25 22.7614 22.7614 25 20 25H6C3.23858 25 1 22.7614 1 20V12Z",
    stroke: "#3E3A33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 20C5 20.5523 5.44772 21 6 21C6.55228 21 7 20.5523 7 20H5ZM7 12C7 11.4477 6.55228 11 6 11C5.44772 11 5 11.4477 5 12H7ZM12 20C12 20.5523 12.4477 21 13 21C13.5523 21 14 20.5523 14 20H12ZM14 12C14 11.4477 13.5523 11 13 11C12.4477 11 12 11.4477 12 12H14ZM19 20C19 20.5523 19.4477 21 20 21C20.5523 21 21 20.5523 21 20H19ZM21 12C21 11.4477 20.5523 11 20 11C19.4477 11 19 11.4477 19 12H21ZM7 20V12H5V20H7ZM14 20V12H12V20H14ZM21 20V12H19V20H21Z",
    fill: "#3E3A33"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_247_6783",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 11.6719H30C31.1046 11.6719 32 12.6617 32 13.8828V18.3047C32 19.5258 31.1046 20.5156 30 20.5156H26M6 20.5156V11.6719Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 9.67188C24.8954 9.67188 24 10.5673 24 11.6719C24 12.7764 24.8954 13.6719 26 13.6719V9.67188ZM26 18.5156C24.8954 18.5156 24 19.4111 24 20.5156C24 21.6202 24.8954 22.5156 26 22.5156V18.5156ZM4 20.5156C4 21.6202 4.89543 22.5156 6 22.5156C7.10457 22.5156 8 21.6202 8 20.5156H4ZM8 11.6719C8 10.5673 7.10457 9.67188 6 9.67188C4.89543 9.67188 4 10.5673 4 11.6719H8ZM26 13.6719H30V9.67188H26V13.6719ZM30 13.6719C29.9731 13.6719 29.9478 13.6651 29.9314 13.6574C29.9171 13.6507 29.9193 13.6482 29.931 13.6611C29.956 13.6888 30 13.7617 30 13.8828H34C34 11.7506 32.3931 9.67188 30 9.67188V13.6719ZM30 13.8828V18.3047H34V13.8828H30ZM30 18.3047C30 18.4258 29.956 18.4987 29.931 18.5264C29.9193 18.5393 29.9171 18.5368 29.9314 18.5301C29.9478 18.5224 29.9731 18.5156 30 18.5156V22.5156C32.3931 22.5156 34 20.4369 34 18.3047H30ZM30 18.5156H26V22.5156H30V18.5156ZM8 20.5156V11.6719H4V20.5156H8Z",
    fill: "#3E3A33",
    mask: "url(#path-3-inside-1_247_6783)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.76f74a7ca8a1df11669df641c9de8a56.svg";
export { ForwardRef as ReactComponent };